import { Trans } from '@lingui/react'
import * as React from 'react'

import { type CartControllerMessageV2 } from 'types/api/cart'
import { NotificationCart } from 'views/components/organisms/Cart/NotificationCart'

interface NotificationVoucherProps {
  messages: CartControllerMessageV2[]
}

const NotificationVoucher: React.FunctionComponent<
  NotificationVoucherProps
> = ({ messages }) => (
  <NotificationCart>
    <Trans id="cart.notification.voucher.cartChange" />
    {messages.length > 0 && (
      <ul>
        {messages.map(message => (
          <li>{message.itemCode}</li>
        ))}
      </ul>
    )}
  </NotificationCart>
)

export { NotificationVoucher }
